import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {CurrencyKindModel} from "./CurrencyKindModel";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class CurrencyCorrection extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(CurrencyCorrection, v) : SKIP;
            },
            (v) => {
                return deserialize(CurrencyCorrection, v) || new CurrencyCorrection();
            }
        );
    }

    constructor(kind = null, percentage = 0) {
        super();
        this._kind = kind;
        this._percentage = percentage;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get percentage() {
        return this._percentage;
    }

    set percentage(value) {
        this._percentage = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.percentage) || this.percentage < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.kind || this.percentage < 0;
    }

    free() {
        return this._percentage === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurrencyCorrection());
        } else if (target instanceof CurrencyCorrection) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CurrencyCorrection, {
    _kind: alias("kind", CurrencyKindModel.schema()),
    _percentage: alias("percentage", Schema.primitive())
});

// _kind: alias("kind", reference("id", (id, cb) => {
//     return cb(null, CurrencyKind.getValue(id));
// }, {
//     beforeDeserialize: function (callback, value, parentValue) {
//         if (parentValue["type"] && !parentValue["kind"]) {
//             callback(null, parentValue["type"])
//         } else {
//             callback(null, value)
//         }
//     }
// })),